import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import CringeShell from './CringeShell';
import { GameHead, TopBar, useSaveScore } from './common';
import { useGameTimer } from './hooks';

const QUESTIONS = [
  { id: 'ans1', scrambled: 'WFGRAPTI', answer: 'giftwrap' },
  { id: 'ans2', scrambled: 'FLESAOWKN', answer: 'snowflake' },
  { id: 'ans3', scrambled: 'ETISOMETL', answer: 'mistletoe' },
];

function Stage2Game() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const game = useSelector((s) => s.cringe.game);
  const timer = useGameTimer(true, game?.time);
  const save = useSaveScore();
  const [values, setValues] = useState({});
  const [status, setStatus] = useState({}); // id -> 'empty' | 'wrong' | 'right'
  const [points, setPoints] = useState(game?.totalScore || 0);
  const [busy, setBusy] = useState(false);

  // stage2.php keyup: red while empty or wrong, green + locked once right (+1 point, once).
  const onChange = (q, raw) => {
    setValues((v) => ({ ...v, [q.id]: raw }));
    const value = raw.toLowerCase().trim();
    if (value === q.answer) {
      setStatus((s) => ({ ...s, [q.id]: 'right' }));
      setPoints((p) => p + 1);
    } else {
      setStatus((s) => ({ ...s, [q.id]: value === '' ? 'empty' : 'wrong' }));
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    const state = await save(2, points, timer.current());
    if (state) navigate({ pathname: '/stage3', search });
    else setBusy(false);
  };

  return (
    <>
      <TopBar time={timer.text} points={points} />
      <div className="cr-stage-body cr-stage2-body">
        <GameHead>
          You're in the middle of Everwood Forest, and are ready to find Cringe’s secret map, which he accidentally
          left behind. But the map is encrypted, can you unscramble it before it's too late?
        </GameHead>
        <form className="cr-stage2-form" onSubmit={onSubmit}>
          {QUESTIONS.map((q) => (
            <div className="cr-stage2-row" key={q.id}>
              <div className="cr-stage2-word">{q.scrambled}</div>
              <input
                type="text"
                className={`cr-stage2-input ${status[q.id] || ''}`}
                value={values[q.id] || ''}
                onChange={(e) => status[q.id] !== 'right' && onChange(q, e.target.value)}
                readOnly={status[q.id] === 'right'}
                pattern="^(?!\s*$).+"
                required
                autoComplete="off"
                autoCapitalize="off"
                spellCheck={false}
              />
            </div>
          ))}
          <button type="submit" className="cr-img-btn cr-next-btn" disabled={busy}>
            <img src="/cringe/img/next.png" alt="Next" />
          </button>
        </form>
      </div>
    </>
  );
}

// stage2.php: unscramble Cringe's map — three words, 1 point each.
export default function CringeStage2() {
  return (
    <CringeShell bg="stage2/stage2_desk.png" bgMob="stage2/stage2_mob.png" stage={2} className="cr-stage cr-stage2">
      <Stage2Game />
    </CringeShell>
  );
}
